import React from "react";
import Header from '../Home/Header';
import AboutOurPartners from "./AboutOurPartners";
import AboutOurPartners2 from "./AboutOurPartners2";
import Footer from '../Home/Footer';

const OurPartners = () => {
  return (
    <>
      <Header />
      <AboutOurPartners />
      <AboutOurPartners2 />
      <Footer />
    </>
  );
};

export default OurPartners;
